import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from "@angular/core";

import { MedTemplateDirective } from "../../../directives/med-template.directive";
import { simpleCompare } from "../../../utils/base.util";
import { MedTabOption } from "../types";

@Component({
  selector: "med-tab-group",
  templateUrl: "./med-tab-group.component.html",
  styleUrls: ["./med-tab-group.component.scss"],
})
export class MedTabGroupComponent<ValueType> implements AfterViewInit {
  constructor(private readonly cd: ChangeDetectorRef) { }

  tabTemplate?: TemplateRef<any>;

  @ContentChild(MedTemplateDirective) template!: MedTemplateDirective;

  @Input() options: MedTabOption<ValueType>[] = [];
  @Input() value?: ValueType;

  @Output() valueChange = new EventEmitter<ValueType>();

  ngAfterViewInit() {
    if (this.template.getType() === "tab") {
      this.tabTemplate = this.template.template;
    }

    this.cd.detectChanges();
  }

  compare(optionValue: ValueType): boolean {
    return simpleCompare(optionValue, this.value);
  }

  onActive({ value }: MedTabOption<ValueType>): void {
    this.valueChange.emit(value);
  }
}
